<div
  (click)="postDetails()"
  class="pb-2 mx-2 rounded-b-lg mb-2 relative post-container"
  [ngClass]="{
    'bg-[#e9faf8] cursor-pointer': posted,
    'bg-[#fff8e9]': planned,
    'bg-red-100 cursor-not-allowed':failed,
    'rounded-t-lg': mediaPreview == ''
  }"
>
  <div class="relative w-full h-[140px] pb-[6px]" *ngIf="mediaPreview!='' && post.postImagesCount ==0">
    <img referrerpolicy="no-referrer" src="{{mediaPreview}}" alt="Nouvelle Collaboration" class="w-full h-[140px] object-cover">
  </div>
  <!-- Other content remains the same -->
  <div class="flex items-center font-roboto relative" (mouseenter)="isGroupNamesToolTip=true" (mouseleave)="isGroupNamesToolTip=false">
    <span
      class="w-full text-[0.85vw] mx-1 truncate"
      [ngClass]="{'pt-2': post.postImagesCount == 0}"
    >
      <span class="inline-container">
        <span class="group-container">
          <span *ngFor="let group of displayedGroups; let i = index">
            {{ group.name }}<span *ngIf="i < displayedGroups.length - 1">, </span>
          </span>
        </span>
        <span *ngIf="hiddenGroupCount > 0" class="hidden-group-count">
          ...+{{ hiddenGroupCount }}
        </span>
      </span>
    </span>
    <span
      *ngIf="isGroupNamesToolTip && post.groups.length > 1 && hiddenGroupCount > 0"
      class="absolute shadow-sm text-xs z-[1000] left-1 top-5 text-slate-600 px-2 py-1 border-2 bg-white rounded-lg max-h-80 overflow-auto tooltip"
    >
      <ul>
        <li *ngFor="let item of post.groups">- {{item.name}}</li>
      </ul>
    </span>
</div>
    <div id="2" class="py-1 w-[95%]">
        <h3 class="text-gray-800 font-bold font-roboto text-[0.9vw] mx-1 w-full hover:line-clamp-none line-clamp-2">{{post.title}}</h3>
    </div>
    <div class="flex py-2 w-[95%]" *ngIf="!mediaPreview">
        <span class="w-full mx-1 text-[0.8vw] line-clamp-3 hover:line-clamp-none text-[#544e61]" [ngClass]="{ 'whitespace-normal line-clamp-2': mediaPreview==''}">
            {{post.text}}
        </span>
    </div>
    <div class="grid grid-cols-8 w-[95%] mx-auto">
        <app-social-media-round-icon *ngFor="let platform of post.platforms" class="col-span-1" [calendar]="true" [smallScreen]="screenHeight<810 || screenWidth<1201" [source]="platform" [greyedOut]="!(platform == 'facebook' && (homePage ? true : currentPlaTformsFilters.isFacebookON) || platform == 'google' && (homePage ? true : currentPlaTformsFilters.isGoogleON) || platform == 'linkedin' && (homePage ? true : currentPlaTformsFilters.isLinkedinON) || platform == 'instagram' && (homePage ? true : currentPlaTformsFilters.isInstagramON))"  ></app-social-media-round-icon>
        <span *ngFor="let emptySpan of numberOfEmptyArray(6-post.platforms.length)" class="col-span-1 text-[0.9vw]"></span>
        <span class="col-span-2 text-[0.9vw] text-right">
          {{postHour}}
        </span>
        <svg *ngIf="failed" width="20" viewBox="0 0 24 24" fill="none" stroke="#fd397a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"/><path d="M12 9v4"/><path d="M12 17h.01"/></svg>
    </div>
</div>